/*import {
    FetchArgs,
    createApi,
    fetchBaseQuery,
    retry,
  } from '@reduxjs/toolkit/query/react'
  const hesaplerLocalHostApi = 'http://localhost:3001/v1'
  const liveApi = 'https://devtest.fincloudy.com/api/v1'
  const localApi = 'https://8b25-176-88-152-18.ngrok-free.app/v1/'
  
  const customBaseQuery =
    // retry(
    async (args: string | FetchArgs, api: any, extraOptions: any) => {
      const result = await fetchBaseQuery({
        baseUrl: '',
        credentials: 'include',
      })(args, api, extraOptions)
  
      // bail out of re-tries immediately if unauthorized or timeout
      // because we know successive re-retries would be redundant
      if (result.error?.status === 401 || result.error?.status === 504) {
        retry.fail(result.error)
      }
  
      return result
    }
  
  export const api = createApi({
    baseQuery: customBaseQuery,
    tagTypes: [
      "Supplier",
      "Subcategory",
      "Product",
      "Invoice",
      "Customer",
      "BankAccount",
      "Receipt",
      "Basket",
      "Team",
      "Offer",
      "FinancingRequest",
      "Finance",
      "FactoringRequestUserTable",
      "FinanceMembers",
      "SupplierNote"
    ],
    endpoints: (builder) => ({}),
  })
  */

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setCredentials, logOut } from "../features/authenticationSlice";
import { getCookie } from "../utils/getCookie";
import { financeBaseApi, purchaseInvoiceApiBase } from "./env";

const baseQuery = fetchBaseQuery({
  //https://desktop.payeda.net/api/v1
  //http://localhost:5000/v1
  // baseUrl: purchaseInvoiceApiBase + "/v1",
  baseUrl: financeBaseApi,
  prepareHeaders: (headers, { getState }) => {
    const token = getCookie("accessToken");
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
      return headers;
    }
  },
});

const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error?.status === 403) {
    // send refresh token to get new access token
    const refreshResult = await baseQuery("/refresh", api, extraOptions);
    if (refreshResult?.data) {
      const user = api.getState().auth.user;
      // store the new token
      api.dispatch(setCredentials({ ...refreshResult.data, user }));
      // retry the original query with new access token
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logOut());
    }
  }

  return result;
};

export const api = createApi({
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "Supplier",
    "Subcategory",
    "Product",
    "Invoice",
    "Customer",
    "BankAccount",
    "Receipt",
    "Basket",
    "Team",
    "Offer",
    "FinancingRequest",
    "Finance",
    "FactoringRequestUserTable",
    "FinanceMembers",
    "SupplierNote",
  ],
  endpoints: (builder) => ({}),
});
